export enum View {
  SIMPLE_SEARCH = 'simpleSearch',
  SQL_QUERY = 'sqlQuery',
}

export enum FilterKeyType {
  String = 'string',
  Object = 'object',
}
